var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"theme-avatar",attrs:{"src":require('~/assets/images/avatar.svg'),"alt":"avatar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }